import Index from '../views/Reports/Index'

let routes = {
    path: '/reports',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [

        {
            path: '/reports',
            name: 'list-reports',
            component: Index,
            meta: {
                pageTitle: 'Relatórios',
                breadcrumb: [
                    {
                        text: 'Relatórios',
                        active: true,
                    },
                ],
                perfil_id: [8],
            },
        }
    ]
};

export default routes;
